export const GRAPH_PROPERTY_HISTORY_QUERY = `
query resiPdp_propertyHistory($listingId: ID!, $fields: [String!]!) {
  listing(listingId: $listingId) {
    listing_id
    field_change_timeline(fields: $fields, period: "365d") {
      field
      changes {
        changed_at
        previous_value
        current_value
        delta_label
      }
    }
  }
}
`
